import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3685ac18"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pay-item wrap" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "price" }


import { ElMessageBox } from 'element-plus'
import { useRouter, useRoute} from 'vue-router'
import { Api } from '@/services/http'


export default /*#__PURE__*/_defineComponent({
  __name: 'PayItem',
  props: {
  chargeType:{
    type:String,required:true,
  },
  targetId:{
    type:String,
    required:true,
  },
  price: {
    type: Number,
    required: false,
  },
  payed: {
    type: Boolean,
    required: false,
  },
},
  emits: ['payed'],
  setup(__props, { emit: __emit }) {

const emits = __emit;

const props = __props
const router = useRouter();

const handlePay = () => {
  ElMessageBox.confirm(`您确认要支付 ${props.price}D币 查看吗`).then(async (res)=>{
    const data = await Api.get(`/client-api/scoreConsume/activeView?changeType=${props.chargeType}&targetId=${props.targetId}`)
    if( data ){
      emits('payed')
    }
  })
}
const handleRecharge = ()=>{
  router.push('/ucenter/pay')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default"),
    (!__props.payed)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, "( 需要消耗：" + _toDisplayString(props.price) + " 个D币 )", 1),
          _createElementVNode("span", {
            class: "btn",
            onClick: handlePay
          }, "购买"),
          _createElementVNode("span", {
            class: "btn",
            onClick: handleRecharge
          }, "D币充值")
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})